import { TPaymentPlan, TPaymentPlansResponse } from '@onesource/schemas';
import { useQueryClient } from '@tanstack/react-query';

export const useGetMemberPaymentPlanByIdQuery = (paymentPlanId: number | string) => {
  const queryClient = useQueryClient();

  const plan = queryClient
    .getQueriesData<TPaymentPlansResponse>({ queryKey: ['billing', 'payment-plans'] })
    .reduce<TPaymentPlan[]>((acc, [, data]) => acc.concat(data?.items ?? []), [])
    .find(p => String(p.paymentPlanId) === String(paymentPlanId));

  return { data: plan as TPaymentPlan | undefined };
};
